import '@components/Battery/SiteUnitCommandsPopup/SiteUnitCommandsPopup.scoped.scss';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from '@mui/material';
import FormattedAlias from '@src/components/_shared/Translations/FormattedAlias';
import storeConnector from '@store/storeConnector';

type persistCommandsPopupProps = {
  onClickHandler: (persistCommandSelection: boolean) => '';
};

function PersistCommandsPopup(props: persistCommandsPopupProps) {
  const dialogActionsStyles = {
    display: 'flex',
    justifyContent: 'center',
    pb: 2,
  };

  return (
    <div className='cover-container cover-container-confirm'>
      <Dialog open>
        <DialogContent>
          <DialogContentText>
            <FormattedAlias id='Persist existing power commands?' />
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={dialogActionsStyles}>
          <Button
            size='small'
            onClick={() => props.onClickHandler(true)}
            variant='contained'
          >
            <FormattedAlias id='Yes' />
          </Button>
          <Button
            size='small'
            onClick={() => props.onClickHandler(false)}
            autoFocus
            variant='outlined'
          >
            <FormattedAlias id='No' />
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default storeConnector(PersistCommandsPopup, {});
